const USER_TOKEN_COOKIE_KEY = 'ob_access_key';
const USER_PERM_COOKIE_KEY = 'ob_perm_key';
const USER_REFRESH_TOKEN_COOKIE_KEY = 'ob_refresh_token_key';
const ANONYMOUS_TOKEN_CACHE_KEY = 'ANONYMOUS_ACCESS_KEY_TOKEN';
const ACTIVE_PROFILE_ID = 'ob_active_profile_id';
const TRACKING_SESSION_KEY = 'ob_tracking_session';
const USER_COUNTRY_CODE = 'ob_country_code';
const COOKIE_USER = 'ob_user';

module.exports = {
  USER_TOKEN_COOKIE_KEY,
  USER_REFRESH_TOKEN_COOKIE_KEY,
  ANONYMOUS_TOKEN_CACHE_KEY,
  USER_PERM_COOKIE_KEY,
  ACTIVE_PROFILE_ID,
  TRACKING_SESSION_KEY,
  USER_COUNTRY_CODE,
  COOKIE_USER,
};
